import { render, staticRenderFns } from "./WorkSelect.vue?vue&type=template&id=6943be60"
import script from "./WorkSelect.vue?vue&type=script&lang=js"
export * from "./WorkSelect.vue?vue&type=script&lang=js"
import style0 from "./WorkSelect.vue?vue&type=style&index=0&id=6943be60&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports